import Cookies from 'js-cookie';

export const getCookie = (key: string) => {
   return Cookies.get(key);
};

export const setCookie = (key: string, value: string, attributes: object = { expires: 1 }) => {
   Cookies.set(key, value, attributes);
};

export const setCookieExpires = (key: string, value: string, attributes: object = { expires: 0.1 }) => {
   Cookies.set(key, value, attributes);
};

export const removeCookie = (key: string, attributes: object = {}) => {
   Cookies.remove(key, attributes);
};

export const removeCookieAll = (attributes: object = {}) => {
   Object.keys(Cookies.get()).forEach((cookie: string) => {
      Cookies.remove(cookie, attributes);
   });
};
